import script from "./IpSchema.vue?vue&type=script&setup=true&lang=js"
export * from "./IpSchema.vue?vue&type=script&setup=true&lang=js"

import "./IpSchema.vue?vue&type=style&index=0&id=2e024eb5&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e024eb5"]])

export default __exports__